import { create } from "zustand";

interface BulkActionState {
  isBulkActionInProgress: boolean;
  setIsBulkActionInProgress: (inProgress: boolean) => void;
}

export const useBulkActionStore = create<BulkActionState>((set) => ({
  isBulkActionInProgress: false,
  setIsBulkActionInProgress: (inProgress) =>
    set({ isBulkActionInProgress: inProgress }),
}));
